import React from "react";
import { strings } from "../../resources/strings";
import { formatString } from "../../utils/UtilityFunctions";

export interface WizardStepHeaderProps {
  /** Category / section label for the current question (e.g. "Get Started"). */
  category: string;
  /** 1-based index of the current question. */
  step: number;
  /** Total number of questions in the form. */
  total: number;
}

/**
 * Metadata row shown directly below the toolbar on every question screen:
 * the question category label and a step counter ("Question 1/24").
 *
 * Mirrors the "Question Topic" block in Figma node 207:7629.
 */
const WizardStepHeader: React.FC<WizardStepHeaderProps> = ({
  category,
  step,
  total,
}) => {
  const counter = formatString(
    strings.reportForm.stepCounter,
    String(step),
    String(total),
  );

  return (
    <div data-testid="wizard-step-header" className="flex flex-col mt-4">
      <span className="text-xl text-black">{category}</span>
      <span className="text-sm text-gray-700">{counter}</span>
    </div>
  );
};

export default WizardStepHeader;
